import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class BudgetKindItemAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetKindItems';

  /**
   * Lấy dữ liệu loại theo mã khoản
   * NXCHIEN 13.04.2022
   */
  getBudgetKindBySubKindCode(budgetSubKindItemCode) {
    let request = {
      url: [this.getAPIUrl(), `DataBudgetKind?budgetSubKindItemCode=${budgetSubKindItemCode}`].join('/'),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Get dữ liệu chuyển từ nguồn
   * @returns
   */
  async fromBudgetKindItem(param = {}) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/list',
      data: {
        Skip: 0,
        Take: 100,
        Sort: 'budget_kind_item_code',
        Columns: 'budget_kind_item_name,budget_kind_item_code,budget_kind_item_id',
        Filter: '[{"Field":"parent_id","Operator":"NOT NULL"}]',
        type: 0,
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Get dữ liệu chuyển từ loại khoản
   * @returns
   */
  async changeKindItem(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/changeKindItem',
      data: {
        ...param,
      },
    };

    return await httpClient.postAsync(request);
  }
}

export default new BudgetKindItemAPI();
